import { Component} from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { BarcodeScanner, BarcodeScannerOptions } from '@ionic-native/barcode-scanner';
import { ScansHistoryProvider } from '../../providers/scans-history/scans-history';

@IonicPage()
@Component({
  selector: 'page-qrscan',
  templateUrl: 'qrscan.html',
})
export class QrscanPage {
  qrRes: string;

  constructor(public navCtrl: NavController, 
              public navParams: NavParams,
              private qrScanner: BarcodeScanner,
              private history: ScansHistoryProvider) {
  }

  ionViewDidLoad() {
    this.scan();
  }

  back(){
    this.navCtrl.pop();
  }

  scan() {
    let options: BarcodeScannerOptions= {
        preferFrontCamera : false, // iOS and Android
        showFlipCameraButton : true, // iOS and Android
        showTorchButton : true, // iOS and Android
        torchOn: true, // Android, launch with the torch switched on (if available)
        //saveHistory: true, // Android, save scan history (default false)
        //prompt : "Place a barcode inside the scan area", // Android
        //esultDisplayDuration: 500, // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
        formats : "QR_CODE", // default: all but PDF_417 and RSS_EXPANDED
        //orientation : "landscape", // Android only (portrait|landscape), default unset so it rotates with the device
        disableAnimations : true, // iOS
        disableSuccessBeep: false // iOS and Android
    }
  this.qrScanner.scan(options)
    .then( (scanData) =>{
        this.qrRes=scanData.text;
        this.history.push('qrs',this.qrRes);
        this.back();
        
    },
    (err) => {
      // An error occurred
      console.log("Scanning failed: " + err);
      alert("Scanning failed: " + err);
    });

  }

}



// WEBPACK FOOTER //
// ./src/pages/qrscan/qrscan.ts